(function() {
  if (window.__faqsAccordionInit) return;
  window.__faqsAccordionInit = true;

  function openItem(item) {
    if (!item) return;
    var header = item.querySelector('.section-faqs__question');
    if (!header) return;
    item.classList.add('section-faqs-accordion-open');
    header.setAttribute('aria-expanded', 'true');
  }

  function openQuestionFromHash() {
    var hash = window.location.hash.slice(1);
    if (!hash) return;
    var target = document.getElementById(hash);
    if (target && target.classList.contains('section-faqs__item')) {
      openItem(target);
      /* Short delay so accordion expand runs, then smooth scroll with top offset (scroll-margin-top in CSS) */
      requestAnimationFrame(function() {
        setTimeout(function() {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      });
    }
  }

  function handleClick(e) {
    var header = e.target.closest('.section-faqs__question');
    if (!header) return;

    var item = header.closest('.section-faqs__item');
    if (!item) return;

    e.preventDefault();
    var isOpen = item.classList.toggle('section-faqs-accordion-open');
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function init() {
    document.addEventListener('click', handleClick);
    openQuestionFromHash();
    window.addEventListener('hashchange', openQuestionFromHash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
